import { render } from "./RecommendationMatrix.vue?vue&type=template&id=09e74349&scoped=true"
import script from "./RecommendationMatrix.vue?vue&type=script&lang=js"
export * from "./RecommendationMatrix.vue?vue&type=script&lang=js"

import "./RecommendationMatrix.vue?vue&type=style&index=0&id=09e74349&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e74349"]])

export default __exports__